import React from 'react';

import { Button, Popup, PopupSection, Text } from '@flixbus/honeycomb-react';

import { useModalDeleteAbsence } from './hooks/useModalDeleteAbsence';
import { DELETE_ABSENCE_TEXT, DELETE_RRO_ABSENCE_TEXT } from './text';

const ModalDeleteAbsence = ({ initialData = {}, onActionSuccess = () => {}, onClose }) => {
	const { loading, confirm } = useModalDeleteAbsence({ initialData, onActionSuccess, onClose });
	const text = initialData?.isRRO ? DELETE_RRO_ABSENCE_TEXT : DELETE_ABSENCE_TEXT;

	return (
		<Popup active id="modal-delete-absence" onOverlayClick={onClose}>
			<PopupSection type="title">{text.title}</PopupSection>

			<PopupSection type="content">
				<Text>{text.content}</Text>
			</PopupSection>

			<PopupSection type="actions">
				<Button onClick={onClose}>{text.cancelButton}</Button>
				<Button appearance="danger" onClick={confirm} loading={loading}>
					<strong>{text.confirmButton}</strong>
				</Button>
			</PopupSection>
		</Popup>
	);
};

export default ModalDeleteAbsence;
